import React, { Suspense } from "react";
import App from "./App";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.css";
import "./locales/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}
    >
      {/* Suspends only while a non-English language's files first load. */}
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
